module.exports = __webpack_public_path__ + "img/finial-classic.45b2858c.jpg";